// @ts-check

import { useState, useEffect } from 'react';
import { useNotificationProvider } from 'hooks';
import getRolesApi from 'api/menus/getRolesApi';
import populateMenus from 'containers/pages/menus/libs/populateMenus';
import getMenuApi from 'api/menus/getMenuApi';
import updateMenu from 'containers/pages/menus/libs/updateMenu';
import updateMenuBySavingData from 'containers/pages/menus/libs/updateMenuBySavingData';

/**
 * @function useMenus
 * @returns {object}
 */
function useMenus() {
	const { notifyError } = useNotificationProvider();

	const [loading, setLoading] = useState(false);
	const [menus, setMenus] = useState([]);
	const [roles, setRoles] = useState([]);
	const [tabs, setTabs] = useState([]);

	/**
	 * @function onMenu
	 * @param {string} type
	 * @param {array} values
	 * @param {string} groupId
	 * @param {string} tabId
	 * @returns {void}
	 */
	const onMenu = (type, values, groupId, tabId) => {
		const results = updateMenu(type, values, menus, groupId, tabId);
		setMenus([...results]);
	};

	/**
	 * @function onUpdateMenu
	 * @param {object} updatedData
	 * @returns {void}
	 */
	const onUpdateMenu = (updatedData) => {
		const results = updateMenuBySavingData(menus, updatedData);
		setMenus([...results]);
	};

	/**
	 * @function onSetMenu
	 * @returns {Promise<void>}
	 */
	const onSetMenu = async () => {
		const _menu = await getMenuApi();
		const _roles = await getRolesApi();
		const apps = populateMenus(_menu, _roles);
		setMenus(apps);
		setRoles(_roles);
		setTabs(_menu.dbTabs);
	};

	useEffect(() => {
		(async () => {
			try {
				setLoading(true);
				await onSetMenu();
			} catch (error) {
				notifyError(error.message);
			} finally {
				setLoading(false);
			}
		})();
	}, [notifyError]);

	return { loading, menus, roles, tabs, onMenu, onUpdateMenu };
}

export default useMenus;
